import {AcPaging} from '../../ac-pagination/ac-paging.interface';
import {AcTableScrollPosition, AcTableSorter} from '../ac-table.interface';
import {AcTableCursor} from '../ac-table-cursor/ac-table-cursor.component';
import {AcTableStateModels} from './ac-table-state.models';

export namespace AcTableActions {

    export class SetTableState {
        static readonly type = '[Table State] Set';
        constructor(public state: AcTableStateModels) {}
    }

    export class Select {
        static readonly type = '[Table Selection] Select';
        constructor(public tableId: string, public selection: any[], public anchor = null, public updateLastState = false) {}
    }
    export class Unselect {
        static readonly type = '[Table Selection] Unselect';
        constructor(public tableId: string, public selection: any, public anchor) {}
    }
    export class ClearSelection {
        static readonly type = '[Table Selection] Clear';
        constructor(public tableId: string, public keepAnchor = false) {}
    }

    export class UpdatePaging {
        static readonly type = '[Table paging] Update';
        constructor(public tableId: string, public paging: AcPaging) {}
    }

    export class UpdateCursor {
        static readonly type = '[Table cursor] Update';
        constructor(public tableId: string, public cursor: AcTableCursor) {}
    }

    export class UpdateSorting {
        static readonly type = '[Table sorting] Update';
        constructor(public tableId: string, public sorting: Array<AcTableSorter>) {}
    }

    export class UpdateScrollPosition {
        static readonly type = '[Table scroll position] Update';
        constructor(public tableId: string, public scrollPosition: AcTableScrollPosition, public update = true) {}
    }

    export class UpdateColumnsWidth {
        static readonly type = '[Table columns width] Update';
        constructor(public tableId: string, public columnsWidth: {[key: string]: number}) {}
    }

    export class UpdateCollapsedGroups {
        static readonly type = '[Table group collapse] Update';
        constructor(public tableId: string, public collapsedGroups, public update = true) {}
    }

    export class SetAllCollapsedGroups {
        static readonly type = '[Table group collapse] Set All';
        constructor(public tableId: string, public state: boolean) {}
    }
}
